<template>
  <AppSection id="languages" :title="$getConst.pages.language.languages" type="page">
    <AppSection
      id="permissions-table"
      :title="$t($getConst.pages.language.list_of_language)"
      type="section"
      :button="hasPermission($getConst.permissions.createLanguage)"
      :button-text="$getConst.pages.button.add"
      :button-icon="$getConst.icons.add"
      @onClick="openLanguageModal"
    >

      <AppDataTable
        ref="languagesTable"
        :fields="fields"
        :actions="actions"
        end-point="languages"
        @onDelete="confirmDelete"
        @onSetting="onSetting"
        @onEdit="edit"
      >
      </AppDataTable>
      <LanguageModal :id="languageAddModal"/>
      <LanguageModal :id="languageEditModal" :language-to-edit="languageToEdit"/>
      <AppConfirmationModal
        id="confirmation-modal"
        :title=$t($getConst.pages.profile.are_you_sure) | capitalize
        ref="confirmDelete"
        @onCancel="cancelDelete"
        @onConfirm="deleteLanguage"/>
    </AppSection>
  </AppSection>
</template>

<script>
  import AppDataTable from "../../components/common/table/AppDataTable";
  import {deleteLanguage} from "../../api/languages.api";
  import LanguageModal from "./LanguageModal";
  import AppSection from "../../components/common/sections/AppSection";
  import AppConfirmationModal from "../../components/common/modals/AppConfirmationModal";
  export default {
    name: "index",
    components: {AppSection, AppConfirmationModal, LanguageModal, AppDataTable},
    data() {
      return {
        languageToDelete: null,
        languageToEdit:null,
        languageAddModal: 'language-add-modal',
        languageEditModal: 'language-edit-modal',
        fields: [
          {key: 'name', sortable: true, filterable: true},
          {key: 'code', sortable: true, filterable: true},
          {key: 'nav_language_id', label:'Navision id', sortable: true, filterable: true},
        ],
        actions: [
          {action: 'onEdit', variant: 'outline-secondary', icon: this.$getConst.icons.edit, permissions: [this.$getConst.permissions.writeLanguage]},
          {action: 'onDelete', variant: 'outline-danger', icon: this.$getConst.icons.delete, permissions: [this.$getConst.permissions.deleteLanguage]},
          {action: 'onSetting', variant: 'outline-warning', icon: this.$getConst.icons.setting, permissions: [this.$getConst.permissions.writeTranslation]},
        ],
      }
    },
    mounted() {
      this.$root.$on('onAddLanguage', language => {
        this.onAddLanguage(language);
      });
      this.$root.$on('onEditLanguage', language => {
        this.onEditLanguage(language);
      });
    },
    methods: {
      confirmDelete(language) {
        this.languageToDelete = language;
        this.$bvModal.show('confirmation-modal')
      },
      cancelDelete() {
        this.languageToDelete = null;
      },
      deleteLanguage() {
        deleteLanguage(this.languageToDelete.id).then(
          () => {
            this.$refs.languagesTable.removeItem(this.languageToDelete);
            this.$refs.confirmDelete.close();
            this.$snotify.success(this.$t(this.$getConst.pages.language.language_deleted));
          },
          (error) => {
            this.handleApiError(error);
          }
        )
      },

      onAddLanguage(language) {
        this.$snotify.success(this.$t(this.$getConst.pages.language.language_added));
        this.$refs.languagesTable.addItem(language);
      },
      edit(language) {
        this.languageToEdit = Object.assign({}, language);
        this.openLanguageEditModal();
      },
      onEditLanguage(language) {
        this.$snotify.success(this.$t(this.$getConst.pages.language.language_updated));
        this.$refs.languagesTable.editItem(language);
      },
      openLanguageModal() {
        this.$bvModal.show(this.languageAddModal);
      },
      openLanguageEditModal() {
        this.$bvModal.show(this.languageEditModal);
      },
      onSetting(language) {
        this.$router.push(
          {
            name: this.$getConst.routesNames.administration.dictionary,
            params: {
              language_code: language.code,
              language_name: language.name
            }
          }
        );
      },
    },
    beforeDestroy() {
      this.$root.$off('onAddLanguage');
      this.$root.$off('onEditLanguage');
    }
  }
</script>

<style >
  .badge {
    height: inherit;
    width: 80%;
  }
</style>
